export const ASIAN_HANDICAP = [20781, 60016, 60169, 4561, 6511, 6515, 6676, 1127, 7844, 7846, 7486, 4813, 1126, 11442, 5373, 9284, 14264, 19685];
export const ASIAN_HANDICAP_IT = [27933, 27985, 27986];
export const ASIAN_HANDICAP_IA = [55, 64, 70];
export const DAYS_FILTERS = ['TODAY', '2D', '3D'];
export const DAYS_FROM_FILTER = {
    'TODAY': 0,
    '1D': 1,
    '2D': 2,
    '3D': 3,
};

export const BET_IDS_TO_SHOW_WITHOUT_ADDITIONAL_INFO = [13353, 24522, 24516, 24487, 24485, 13657, 21073, 24481,
                                                        24521, 21079, 9900, 13661, 18568, 20207, 24483, 13656,
                                                        20203, 21074, 24546, 24558, 24552, 24556, 24560, 24008,
                                                        9900, 19525, 21309, 24571, 24629, 24631, 24572, 24573,
                                                        24574, 24576, 26998, 13720, 13721, 14131, 14376, 14852,
                                                        24575, 16474, 16989, 14422, 14423, 14424, 14425,
                                                        14600, 25195, 25197, 25646, 25371, 9900, 19804, 19822,
                                                        13397, 13398, 24529, 13399, 19412, 16713, 13458, 9900,
                                                        24936, 22686, 13519, 24007, 9900, 24634, 14376, 14852,
                                                        22797, 22798, 27302, 17589, 9900, 17604, 9900, 20492,
                                                        9900, 26327, 15854, 9900, 15956, 25509, 23558, 9900,
                                                        16035, 21305, 9900, 22580, 21060, 9900, 16190, 9900
                                                        ];
export const HANDICAP_TYPES_TO_FORCE_ONE_COLUMN = [5, 6];
export const HANDICAP_TYPES_TO_SHOW_WITHOUT_HANDICAP = [5, 6, 7, 23, 40, 46, 50];
export const HANDICAP_TYPES_TO_SORT_BY_DESC = [35, 38];
export const HANDICAP_TYPES_64_BITS = new Set([57, 58, 59, 60, 61, 62, 63, 64, 65, 67, 68, 69, 71, 72]);
export const HOURS_FILTERS = ['1H', '3H'];
export const HOURS_FROM_FILTER = {
    '1H': 1,
    '3H': 3,
};
export const HEADER_WIDE_BOX_HANDICAP_TYPES = [6, 7, 34, 35, 37, 38, 44];
export const INFO_AGG_NEED_TO_BE_AGG = [35, 37, 38, 6, 56];
export const LIST_BETS_HANDICAP_TYPES = [6, 35, 37, 38, 56];
export const LIST_BETS_MOBILE = [6, 7, 34, 35, 38];
export const MAX_COLUMNS = 12;
export const SERVING_SPORTS = [5, 20, 23, 34];
export const SOCCER_SPORT_ID = 1;
export const SPORTS_WITH_STAGE_ID = [11, 40];
// WILLIAMHILL
export const TEMPORAL_FILTERS = ['1H', '3H', 'TODAY', '2D', '3D', 'ALL'];
export const TEMPORAL_FILTERS_WITH_LIVE = ['LIVE', '1H', '3H', 'TODAY', '2D', '3D', 'ALL'];

export const TIME_FILTERS = ['1H', '3H', 'TODAY', '2D', '3D'];
export const WIDE_BOX_HANDICAP_TYPES = [6, 7,  34, 35, 38, 37, 44, 56];
export const SPORTS_TO_SHOW_WITHOUT_TIME = new Set([5, 34]);
export const GROUPED_VIEW_MARKETS = [14441, 14442, 15377, 15378, 15379, 15410, 16835, 17272, 17273, 17274, 20808, 22636, 22485, 22610, 23509, 24590, 24591, 24593, 25219, 25220, 25467, 26507, 26515, 26777, 26874, 26879];

// Sport IDs
export const SOCCER = 1;
export const BASKET = 2;
export const TENNIS = 5;

// XShop constants
export const XSHOP_MAX_BETSLIP_SELECTIONS = 30;
export const IDLE_LOOP_DEFAULT_TIMEOUT_MS = 180000;
export const IDLE_LOOP_POPUP_TIMEOUT_MS = 10000;
export const ERR_CF_POPUP_TIMEOUT = 5000;
export const L_STORAGE_KEY_FREEZE_SECOND_SCREEN = 'freeze_sc';
export const FREEZE_SECOND_SCREEN_ASK_CF = 'ask_cf';
export const FREEZE_SECOND_SCREEN_MENU_APP = 'menu_app';
export const FREEZE_SECOND_SCREEN_GENERIC = 'generic';
export const L_STORAGE_KEY_ONLY_VIRTUAL_PROTOCOL = 'psv_only';
export const L_STORAGE_KEY_ONLY_HORSING_RACE_PROTOCOL = 'hr_only';
export const L_STORAGE_KEY_HIDE_BALANCE = 'hide_balance'
export const L_STORAGE_KEY_SHOW_PROFILE = 'show_profile'
export const HANDICAP_TYPES_RELATED=[6,7,34,35, 37,38]
